import src from "IMAGE";
export default { src, width: 573, height: 1179, blurWidth: 4, blurHeight: 8, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAICAYAAADeM14FAAAAR0lEQVR42n3KQQqAQAwDwB5MrJX23F2/0P+/TyoKejEQCEPEI0pVU3VL9ygh1yl3AI6G44Frk3w/5gcWYPwDGsz2ApldM6sTFHwD9Eme71wAAAAASUVORK5CYII="};
